export default "__VITE_ASSET__d11ca0d3__"